
export default [
    {
        id: "estimate_header",
		header: "Цагийн тооцоо",
	},
	{
        id: 'volume',
        title: 'Цагийн ачаалал',
        icon: <i className="fal fa-watch"></i>,
        navLink: "/volume",
    },
    {
        id: 'estimation',
        title: 'А цагийн тооцоо',
        icon: <i className="far fa-calculator-alt"></i>,
        navLink: "/a_estimation",
    },
    {
        id: 'part_time',
        title: 'Цагийн багш тооцоо',
        icon: <i className="fas fa-user-clock"></i>,
        navLink: "/part-time",
    },
]
